<template>
    <div class="problem">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Problem'
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .problem
    {
        
    }
</style>
